import { CForm, CFormInput, CButton, CFormTextarea, CTooltip, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import HighlightedText from '../../components/shared/HighlightedText'
import { usePDF } from 'react-to-pdf'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import LabDisplayComponent from './LabDisplayComponent'
import FinalNoteDisplayImaging from './FinalNoteDisplayImaging'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import { Check, CircleAlertIcon, Plus, Info, Pencil, Trash2, Pointer } from 'lucide-react'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import AsseseementFinalNote from './Asseseement'
import { Form } from '@formio/react'
import PatientQuestionPoa from './PatientQuestionPoa'
import PatientTreatmentsPlans from './PatientTreatmentsPlans'
import PatientRisk from './PatientRisk'
import PatientDifferentialDiagnosis from './PatientDifferentialDiagnosis'
import MultiSelect from '../../components/shared/MultiSelect'
import MorseBimsScore from '../../components/shared/MorseBimsScore'
import MorseScore from '../../components/shared/MorseScore'
import MobilityAssessment from '../../components/shared/MobilityAssessment'
import SelfCareAssessment from './SelfCareAssessment'
import FallsAssessment from '../../components/shared/FallsAssessment'
import HPIQuestions from './HPIQuestions'
import PatientIncidet from './PatientIncidet'
import PatientAlerts from './PatientAlerts'
import ReviewOfSystem from './ReviewOfSystem'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import PhysicalExaminationVisualNote from './PhysicalExaminationVisualNote'
import PatientIncidentGlobal from './PatientIncidentGlobal'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import ProviderHpiQuestions from './ProviderHpiQuestion'
import ProviderReviewSystem from './ProviderReviewSystem'
import ProviderPatientAllergies from './ProviderAllergies'
import ProviderPatientLabs from './ProviderPatientLabs'
import PatientImagingsCRUD from '../../../src/services/general/patientImagingData'
import PhysicalProviderExaminationVisualNote from './PhysicalProviderExaminationVisualNote'
import HighlightedTextImaging from './HighlghtedImaging'
import Highlighter from 'react-highlight-words'

const ProviderFinalNote = ({
  patientID,
  targetRef,
  vitalsList,
  addendumData,
  setActiveTabPatientInfo,
  fetchPatientLabs,
  setDataId,
  selectedRisks,
  setAllLabs,
  setNewLabsAdded,
  loading,
  setLoading,
  isAllotedToProvider,
  saveTreatsShell,
  statusPatientNote,
  setSelectedRisks,
  diagnosisCode,
  allLabs,
  toPDF,
  patientData,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  imagingTypeList,
  noteStructureRef,
  patientTreatments,
  GetMasterMedications,
  masterMedications,
  setMasterMedications,
  hospitalRecords,
  setHospitalRecords,
  diagnosisAddedPinger,
  patientSidebarActiveTab,
  allergies,
  patientDiagnosis,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  addDiagnosisIdsToNote,
  setImaging,
  activeTab,
  selectedDifferentialDiagnosis,
  setSelectedDifferentialDiagnosis,
  showComment,
  noteID,
  updatePatientDiagnosis,
  editPatientDiagnosis,
  deletePatientDiagnosis,
  updateNoteStructure,
}) => {
  const [riskfactors, setRiskFactors] = useState({})
  const [patientDifferentialDiagnosis, setSelectedPatientDifferentialDiagnosis] = useState({})
  const [questions, setQuestions] = useState([])
  const [riskFactorWithKeyword, setRiskFactorsWithKeyword] = useState({})
  const [diagnosisLabMap, setDiagnosisLabMap] = useState({})
  const [formAnswers, setFormAnswers] = useState([])
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [editDiagnosis, setEditDiagnosis] = useState(null)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [dataWithoutValues, setDataWithoutValues] = useState([])
  const [formValue, setFormValues] = useState([])
  const [questionValue, setQuestionsValue] = useState([])
  const [noteRefTrigger, setNoteRefTrigger] = useState(0)
  const [addedNewIncident, setAddedNewIncident] = useState(false)

  const formioOptions = {
    readOnly: true,
    renderMode: 'html',
  }

  const showDataIfNoteIsFollowUp = statusPatientNote === 'Follow Up' ? true : false // not showing data if note is follow up

  const [visible, setVisible] = useState(false)
  const historyTypeMapping = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }
  const getLabs = () => {
    let noteLabs = localStorage.getItem('notesLabs')
    try {
      let labs = JSON.parse(noteLabs)

      if (labs) {
        let diagnosisMap = filterLabsByDiagnosis(labs)
        setDiagnosisLabMap(diagnosisMap)
      }
    } catch (e) {}
  }

  const getRisks = async (diagnosisList) => {
    let responseRisks = await GetDiagnosisData('Risks')

    try {
      let risks = JSON.parse(responseRisks.d)?.Data
      let riskFactorsWithKeywordss = {}
      let allRisks = {}

      diagnosisList.forEach((diagnosis) => {
        let riskObj = risks.find((obj) => obj.Name.trim() == diagnosis.trim())
        if (riskObj) {
          riskFactorsWithKeywordss[diagnosis] = JSON.parse(riskObj?.RiskFactors1)
        } else {
          riskFactorsWithKeywordss[diagnosis] = []
        }
      })

      setRiskFactorsWithKeyword(riskFactorsWithKeywordss)

      diagnosisList.forEach((diagnosis) => {
        let riskObj = risks.find((obj) => obj.Name.trim() == diagnosis.trim())
        if (riskObj) {
          allRisks[diagnosis] = riskObj.RiskFactors.split(',')
        } else {
          allRisks[diagnosis] = []
        }
      })

      setRiskFactors(allRisks)
    } catch (e) {
      console.error('Failed to parse risks from local storage', e)
    }
  }

  const getPatientHistory = async () => {
    const historyKeys = Object.keys(historyTypeMapping)

    try {
      const results = await Promise.all(
        historyKeys.map(async (key) => {
          const historyType = historyTypeMapping[key]
          const response = await getPatientPersonalHistory('GET', patientID, historyType, '')
          const parsed = JSON.parse(response?.d)
          return { key, data: parsed?.Data || [] }
        }),
      )

      const updatedHistories = results.reduce((acc, { key, data }) => {
        acc[key] = data
        return acc
      }, {})

      setPersonalHistory(updatedHistories)
    } catch (error) {
      console.error('Error fetching patient histories:', error)
      toast.error('Failed to load patient history.', toastConfig)
    }
  }

  useEffect(() => {
    getPatientHistory()
  }, [])
  const getDifferentialDiagnosis = async (diagnosisList) => {
    let responseDifferentialDiagnosis = JSON.parse(localStorage.getItem('DifferentialDiagnosis')) || []
    try {
      // risks = JSON.parse(risks);
      // let risks = JSON.parse(responseRisks.d)?.Data;

      // let  = localStorage.getItem("Risks")
      let allDifferentialDiagnosis = {}

      // Iterate over each diagnosis

      diagnosisList.forEach((diagnosis) => {
        // Find the risk object that matches the diagnosis name

        let DdObj = responseDifferentialDiagnosis.find((obj) => obj.Name.trim() == diagnosis.trim())
        if (DdObj) {
          // Assign the risks to the corresponding diagnosis name in the allDifferentialDiagnosis object
          allDifferentialDiagnosis[diagnosis] = DdObj.DifferentialDiagnosis.split(',')
        } else {
          // If no risks found for the diagnosis, you can initialize it as an empty array or handle it accordingly
          allDifferentialDiagnosis[diagnosis] = []
        }
      })

      setSelectedPatientDifferentialDiagnosis(allDifferentialDiagnosis)
    } catch (e) {
      console.error('Failed to parse risks from local storage', e)
    }
  }

  const formData = useRef([])

  const filterEmptyAnswers = (data) => {
    return data
      .filter((item) => typeof item === 'object' && !Array.isArray(item))
      .map((item) => {
        return {
          ...item,
          data: Object.fromEntries(Object.entries(item.data).filter(([key, value]) => value !== '')),
        }
      })
  }

  const [newComponents, setNewComponents] = useState([])

  const vitalFields = {
    BloodPressure: { label: 'Blood Pressure', unit: 'mmHg' },
    HeartRate: { label: 'Heart Rate', unit: 'bpm' },
    RespiratoryRate: { label: 'Respiratory Rate', unit: 'rpm' },
    Temperature: { label: 'Temperature', unit: '°F' },
    SpO2: { label: 'SpO2', unit: '%' },
    InhaledO2: { label: 'Inhaled O2', unit: '%' },
    HeartCirc: { label: 'Heart Circ', unit: 'in' },
    Height: { label: 'Height', unit: 'ft/in' },
    Weight: { label: 'Weight', unit: 'lbs/oz' },
  }

  const getCallCenterData = async (diagnosisList) => {
    let tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
    try {
      let data = JSON.parse(tempAnswers.d)
      let formAnswersStr = data.Data[0].DiagnosisDetails
      let tempData = JSON.parse(formAnswersStr)
      let resultData = filterEmptyAnswers(tempData)
      setDataWithoutValues(resultData.map((item) => item.data).reduce((acc, obj) => ({ ...acc, ...obj }), {}))
      setFormAnswers(tempData)
      setFormValues(resultData)
    } catch (e) {}
    const updatedComponents = []

    for (let a = 0; a < diagnosisList.length; a++) {
      try {
        formData.current.push([])
        try {
          let component = []
          let c = await GetQuestionBank('', diagnosisList[a], '')
          component = JSON.parse(c.d)

          updatedComponents.push({ diagnosis: diagnosisList[a], component: component })
        } catch (e) {
          console.log('error ', e)
        }
      } catch (e) {
        console.log('Error Fetching Diagnosis Data: ', diagnosisList[a], e)
      }
    }
    setNewComponents(updatedComponents)
  }

  let tempData = []
  useEffect(() => {
    if (newComponents.length > 0) {
      newComponents.forEach((form) => {
        if (form?.component.components) {
          form?.component.components.forEach((comp) => {
            if (!dataWithoutValues.hasOwnProperty(comp.key)) {
              comp.hidden = !dataWithoutValues[comp.key]
            }
          })
        }

        let componentKeys = form.component.components.map((item) => item.key)
        let filteredData = formValue
          .map((item) => {
            let matchedKeys = Object.keys(item.data).filter((key) => componentKeys.includes(key))
            if (matchedKeys.length > 0) {
              let filteredObj = {}
              matchedKeys.forEach((key) => {
                filteredObj[key] = item.data[key]
              })
              return filteredObj
            }
            return null
          })
          .filter(Boolean)

        if (filteredData.length > 0) {
          // setQuestionsValue((prev) => [...prev, {
          //     diagnosis: form?.diagnosis,
          //     data: filteredData
          // }])
          tempData.push({
            diagnosis: form?.diagnosis,
            data: filteredData,
          })
        }
      })

      setQuestions(newComponents)
      setQuestionsValue(tempData)
    }
  }, [newComponents])

  const DiagnosisOptions = async () => {
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      const options = diagnosis.map((item) => ({
        value: item.id,
        label: item.Name,
      }))
      setDiagnosisOptions(options)
    } catch (error) {
      console.error('Error updating diagnosis options:', error)
    }
  }
  useEffect(() => {
    getCallCenterData(patientDiagnosis)
    getLabs()
    getRisks(patientDiagnosis)
    getDifferentialDiagnosis(patientDiagnosis)
    DiagnosisOptions()
  }, [])

  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const getDiagnosisMedicationInRisk = (diagnosisName) => {
    if (masterMedications.length > 0) {
      const lastMedicationAdded = medication[medication.length - 1]
      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded
      const matchingDiagnoses = data.map((med) => {
        const matchingMasterMed = masterMedications.find((item) => item.Data.name === med.name)
        return matchingMasterMed
      })
      let name
      matchingDiagnoses.find((item) => {
        if (item?.Data.diagnoses.includes(diagnosisName)) {
          name = item.Data
        }
      })
      return name
    } else {
      return 'Not enough information'
    }
  }

  const hasAnyAnswer = (data) => {
    return Object.values(data).some((value) => {
      return typeof value === 'string' && value.trim() !== ''
    })
  }

  const handleSaveDiagnosis = () => {
    editPatientDiagnosis(patientID, editDiagnosis, selectedDiagnosis.label)
    setVisible(false)
    setEditDiagnosis(null)
  }
  const handleDeleteDiagnosis = () => {
    deletePatientDiagnosis(patientID, editDiagnosis)
    setEditDiagnosis(null)
    setDeleteVisible(false)
  }

  const [allTreamentStatements, setAllTreatmentStatements] = useState([])
  const getTreatmentPlansData = async () => {
    let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
    data = JSON.parse(data.d)?.Data || []
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
    }
    setAllTreatmentStatements(data)
  }

  useEffect(() => {
    getTreatmentPlansData()
  }, [])

  useEffect(() => {
    if (patientTreatments[noteID].data.riskFactors) {
      setSelectedRisks(patientTreatments[noteID].data.riskFactors || {})
    }
  }, [])

  return (
    <div className="mt-4 d-flex flex-column p-8">
      <div>
        <div className="d-flex flex-column gap-2">
          {addendumData && addendumData?.orders && addendumData.orders?.length > 0 && (
            <CAccordion>
              <CAccordionItem itemKey={1}>
                <CAccordionHeader style={{ background: '#191919' }}>Addendum</CAccordionHeader>
                <CAccordionBody>
                  {addendumData && addendumData.orders && addendumData.orders.length > 0 ? (
                    addendumData.orders.map((item, idx) => {
                      const currentOrder = item
                      return (
                        <div key={idx} className="">
                          <div className="">
                            <div className="">
                              {/* Date */}
                              <div className="">
                                <div>
                                  <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                  {(() => {
                                    const parts = addendumData?.syncDate?.split('-')
                                    if (!parts || parts.length !== 3) return ''
                                    const [month, day, year] = parts
                                    const date = new Date(`${year}-${month}-${day}`)
                                    return new Intl.DateTimeFormat('en-US', {
                                      day: '2-digit',
                                      month: '2-digit',
                                      year: 'numeric',
                                    }).format(date)
                                  })()}
                                </div>
                                {currentOrder?.diagnosis && (
                                  <p className="mb-1" style={{ marginTop: '-8px' }}>
                                    <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                  </p>
                                )}
                              </div>

                              {/* Medications */}
                              {currentOrder?.medication?.medication?.length > 0 && (
                                <div className="mb-2">
                                  <p className="text-secondary fw-bold mb-1">Medications:</p>
                                  <ol>
                                    {currentOrder.medication.medication.map((medItem, mIdx) => (
                                      <li className="p-0 m-0" key={mIdx}>
                                        {medItem?.name} {medItem?.dosage} {medItem?.route} {medItem?.frequency}
                                        {medItem?.reason && ` - ${medItem.reason}`}
                                         {medItem?.code && ` - ${medItem.code}`}
                                      </li>
                                    ))}
                                  </ol>
                                </div>
                              )}

                              {/* Labs */}
                              {currentOrder?.lab?.labs?.length > 0 && (
                                <div className="mb-2">
                                  <p className="text-secondary fw-bold mb-1">Labs:</p>
                                  <ol>
                                    {currentOrder.lab.labs.map((labItem, lIdx) => (
                                      <li className="p-0 m-0" key={lIdx}>
                                        {labItem?.lab}
                                        {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                         {labItem?.code && ` - Code for ${labItem.lab}: ${labItem.code}`}
                                      </li>
                                    ))}
                                  </ol>
                                </div>
                              )}

                              {/* Imaging */}
                              {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                <div className="mb-2">
                                  <p className="text-secondary fw-bold mb-1">Imaging:</p>
                                  <ol>
                                    {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                                      <li className="p-0 m-0" key={iIdx}>
                                        {imagingItem?.type}
                                          {imagingItem?.reason}
                                            {imagingItem?.code}
                                      </li>
                                    ))}
                                  </ol>
                                </div>
                              )}

                              {/* Miscellaneous */}
                              {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                <div className="mb-2">
                                  <p className="text-secondary fw-bold mb-1">Miscellaneous:</p>
                                  <ol>
                                    {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                      <li className="p-0 m-0" key={xIdx}>
                                        {miscItem}
                                      </li>
                                    ))}
                                  </ol>
                                </div>
                              )}

                              {/* POAC */}
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">POAC:</p>
                                <p className="p-0 ms-4" style={{ whiteSpace: 'pre-line' }}>
                                  {addendumData?.poac?.[0]?.poacData?.content}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div className="text-center text-muted py-3">No addendum available.</div>
                  )}
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>
          )}

          {/* Hospital Records */}
          <CAccordion>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader>Hospital Records</CAccordionHeader>
              <CAccordionBody>
                {hospitalRecords
                  .filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId)
                  .map((record, index) => {
                    const rows = Math.max(4, Math.ceil(record.History.length / 50))
                    return (
                      <>
                        <div contentEditable suppressContentEditableWarning={true} className="my-1" style={{ whiteSpace: 'pre-line' }}>
                          {record.History}
                        </div>
                      </>
                    )
                  })}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>
          {/* not showing the histories and allergies in final note when note is followup */}

          {!showDataIfNoteIsFollowUp && (
            <CAccordion alwaysOpen className="d-flex flex-column gap-2">
              {Object.entries(personalHistory).map(([key, histories], index) => {
                return (
                  <CAccordionItem className="border" itemKey={index}>
                    <CAccordionHeader>{historyMapping[key]}</CAccordionHeader>
                    <CAccordionBody className="d-flex flex-column" style={{ gap: '3rem' }}>
                      {/* filter(item => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]]) */}
                      {histories
                        ?.filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                        ?.map((item, index) => (
                          <div key={index} contentEditable suppressContentEditableWarning={true} style={{ whiteSpace: 'pre-line' }} className="">
                            {item[historyObjectKeysParticular[key]]}
                          </div>
                        ))}
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })}
            </CAccordion>
          )}

          {/* not showing the histories and allergies in final note when note is followup */}

          {!showDataIfNoteIsFollowUp && <ProviderPatientAllergies noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} allergiesList={allergies} setAllergiesList={setAllergies} />}
          <CAccordion alwaysOpen activeItemKey={2}>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader>Vitals</CAccordionHeader>
              <CAccordionBody>
                {vitalsList?.slice(-1).map((item, index) => {
                  return (
                    <div key={index}>
                      {Object.entries(item).map(([key, value]) => {
                        if (key === 'Remarks' || key === 'ID' || key === 'PatientID') return null

                        // Format Date
                        if (key === 'Date') {
                          const dateObj = new Date(value)
                          const formattedDate = `${String(dateObj?.getMonth() + 1).padStart(2, '0')}/${String(dateObj?.getDate()).padStart(2, '0')}/${dateObj?.getFullYear()}`

                          return (
                            <div key={key} style={{ marginBottom: '0.5rem' }}>
                              <strong>Date:</strong> {formattedDate}
                            </div>
                          )
                        }

                        return (
                          <div key={key} style={{ marginBottom: '0.5rem' }}>
                            <strong>{key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}:</strong> {value} {vitalFields[key]?.unit}
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>

          <CAccordion alwaysOpen activeItemKey={2}>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader>Medication</CAccordionHeader>
              <CAccordionBody>
                {medication.length > 0 &&
                  (() => {
                    const selectedMedication = medication.find((item) => item.id === noteStructureRef.current?.metadata?.medId)
                    return (
                      <div className="flex flex-column gap-3">
                        {selectedMedication?.data?.map((items, idx) => (
                          <div key={idx} className="d-flex align-items-center gap-2">
                            <p contentEditable suppressContentEditableWarning={true} className="m-0">
                              <b>Name:</b> {items.name}
                            </p>
                            <p contentEditable suppressContentEditableWarning={true} className="m-0">
                              <b>Dosage:</b> {items.dosage}
                            </p>
                            <p contentEditable suppressContentEditableWarning={true} className="m-0">
                              <b>Route:</b> {items.route}
                            </p>
                            <p contentEditable suppressContentEditableWarning={true} className="m-0">
                              <b>Frequency:</b> {items.frequency}
                            </p>
                          </div>
                        ))}
                      </div>
                    )
                  })()}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>

          <ProviderPatientLabs
            saveTreatsShell={saveTreatsShell}
            fetchPatientLabs={fetchPatientLabs}
            setDataId={setDataId}
            setNewLabsAdded={setNewLabsAdded}
            updatePatientDiagnosis={updatePatientDiagnosis}
            diagnosis={patientDiagnosis}
            patientID={patientID}
            allLabs={allLabs}
            setAllLabs={setAllLabs}
            loading={loading}
            setLoading={setLoading}
            noteStructureRef={noteStructureRef}
            showComment={showComment}
            addDiagnosisIdsToNote={addDiagnosisIdsToNote}
          />

          <CAccordion>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader>Imaging</CAccordionHeader>
              <CAccordionBody>
                {imaging.length > 0 &&
                  [...imaging]
                    ?.filter((obj) => noteStructureRef?.current?.metadata?.imagingIds?.includes(obj?.id))
                    ?.sort((a, b) => new Date(b?.date) - new Date(a?.date))
                    .map((obj, idx) => (
                      <div key={idx} className="mb-3">
                        <b contentEditable suppressContentEditableWarning={true}>
                          {new Date(obj?.date).toLocaleDateString('en-US', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                          })}
                          : {obj.data?.name}
                        </b>
                        <p contentEditable suppressContentEditableWarning={true}>
                          {/* <HighlightedText text={obj.data?.impression} keywords={obj.data?.keywords}></HighlightedText> */}
                          {/* <HighlightedTextImaging text={obj?.data?.impression} keywords={obj?.data?.keywords}></HighlightedTextImaging> */}
                          {/* <Highlighter highlightClassName="YourHighlightClass" autoEscape={true} textToHighlight={obj?.data?.impression || ''} searchWords={obj?.data?.selectedText || []} /> */}
                          <Highlighter
                            textToHighlight={obj?.data?.impression || ''}
                            searchWords={obj?.data?.selectedText || []}
                            highlightStyle={{
                              backgroundColor: 'transparent',
                              color: 'orange',
                              fontWeight: 'bold',
                            }}
                          />
                          {showComment && obj?.data?.comment}
                        </p>
                      </div>
                    ))}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>

          <ProviderHpiQuestions
            activeTab={activeTab}
            saveTreatsShell={saveTreatsShell}
            patientData={patientData}
            noteStructureRef={noteStructureRef}
            addDiagnosisIdsToNote={addDiagnosisIdsToNote}
            isAllotedToProvider={isAllotedToProvider}
            patientDiagnosis={patientDiagnosis}
            diagnosis={patientDiagnosis}
            noteID={noteID}
            showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
            patientID={patientID}
          />

          <PatientIncidentGlobal setAddedNewIncident={setAddedNewIncident} saveTreatsShell={saveTreatsShell} isAllotedToProvider={isAllotedToProvider} patientID={patientID} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} />

          <ProviderReviewSystem isAllotedToProvider={isAllotedToProvider} noteStructureRef={noteStructureRef} />

          <PhysicalProviderExaminationVisualNote noteID={noteID} isAllotedToProvider={isAllotedToProvider} patientID={patientID} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} patientDiagnosis={patientDiagnosis} />
        </div>

        {/* Allergies */}

        {/* Medications */}
        {/* <div className='card mb-4 p-3'>
                    <h6 className='fs-7 text-primary' style={{ color: "#808080", opacity: "0.8" }}>Medications</h6>
                    <CForm>
                        {medication.length > 0 && (
                            <div className='flex flex-column gap-3'>
                                {medication[0].data.map((items, idx) => (
                                    // {medication[medication.length - 1].data.map((items, idx) => (
                                    <div key={idx} className='d-flex align-items-center gap-2'>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Date:</b> {new Date(medication[medication.length - 1].date).toLocaleDateString('en-US',{
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Name:</b> {items.name}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Dosage:</b> {items.dosage}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Route:</b> {items.route}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Frequency:</b> {items.frequency}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </CForm>
                </div> */}

        {/* Medications */}

        {/* Labs */}
        {/* <div className='card mb-4 p-3'>
                    <h6 className='fs-7 text-primary' style={{ color: "#808080", opacity: "0.8" }}>Labs</h6>
                    <div className='d-flex flex-column gap-3'>
                        {allLabs.length > 0 && allLabs.filter(item => item.id === noteStructureRef.current?.metadata?.labId).map((obj, idx) => {
                            return (
                                <div key={idx} className=''>
                                    <p className='p-0 m-0' contentEditable suppressContentEditableWarning={true}>
                                        {new Date(obj?.date).toLocaleDateString('en-US', {
                                            month: '2-digit',
                                            day: '2-digit',
                                            year: 'numeric'
                                        })}
                                    </p>
                                    <div>
                                        {
                                            obj.data?.map((item, index) => {
                                                return (
                                                    <div key={idx} className='d-flex gap-1 p-0 m-0'>
                                                        <p className='p-0 m-0'>{item.name}</p>
                                                        <p className='p-0 m-0'>{item.value}</p>
                                                        <p className='p-0 m-0'>{item.unit}</p>
                                                        <p>{item.range}</p>
                                                        <p>{item.diagnosis}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div> */}

        <CModal visible={visible} onClose={() => setVisible(false)}>
          <CModalHeader>
            <CModalTitle>Edit Diagnosis</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div>
              <div className="mb-3  mx-auto" style={{ width: '75%' }}>
                <CFormLabel style={{ fontSize: '16px', fontWeight: '500' }}>Select Diagnosis</CFormLabel>
                <MultiSelect
                  value={selectedDiagnosis}
                  onChange={(e) => {
                    setSelectedDiagnosis(e)
                  }}
                  options={diagnosisOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select or create Diagnosis"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: '#ced4da',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#80bdff',
                      },
                    }),
                  }}
                />
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setVisible(false)}>
              Close
            </CButton>
            <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={handleSaveDiagnosis}>
              Save{' '}
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal backdrop="static" visible={deleteVisible} onClose={() => setDeleteVisible(null)}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisible(null)
              }}
              variant="outline"
              color="secondary"
            >
              Close
            </CButton>
            <CButton variant="outline" onClick={() => handleDeleteDiagnosis()} color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </div>
  )
}

export default ProviderFinalNote
